<template>
    <footer class="footer">
        <div class="container">
            <div class="footer-content">

                <div class="footer-section main-section">
                    <h4>{{ platformName }} ©</h4>
                    <h5>{{ $t('Technology Marketplace for Smart Mobility') }}</h5>
                    <p>{{ $t('Footer text') }}</p>
                </div>

                <div class="extra-content">
                    <div class="footer-section">
                        <h4>{{ $t('Links') }}</h4>
                        <ul>
                            <li><router-link to="/home">{{ $t('Home') }}</router-link></li>
                            <li><router-link to="/services">{{ $t('Services') }}</router-link></li>
                            <li><router-link to="/use-cases">{{ $t('Use cases') }}</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-section footer-box">
                        <ul>
                            <li><router-link to="/applications">{{ $t('Applications') }}</router-link></li>
                            <li><router-link to="/data-space">{{ $t('Data space') }}</router-link></li>
                            <li><router-link :to="`/user/@${user}`">{{ $t('Profile') }}</router-link></li>
                        </ul>
                    </div>
                    <div class="footer-section footer-box">
                        <ul>
                            <li><router-link to="/terms">{{ $t('Terms of use') }}</router-link></li>
                            <li><router-link to="/cookies">{{ $t('Cookies policy') }}</router-link></li>
                            <li><router-link to="/privacy">{{ $t('Privacy policy') }}</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "FooterComponent",
    props: {
        user: { type: String, default: "" },
    },
    data() {
        return {
            platformName: import.meta.env.VITE__PLATFORM_NAME || "Cibermov Marketplace",
            showMore: false,
            isMobile: window.innerWidth <= 999,
        };
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        toggleContent() {
            this.showMore = !this.showMore;
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 999;
        },
    },
};
</script>

<style scoped>
.footer {
    background-color: var(--color-surface);
    border-top: 1px solid var(--color-border);
    padding: var(--space-32) 0;
    width: 100%;
    margin-top: auto;
    padding-top: 64px;
}

.footer-box ul{
    margin-top: 39px !important;
}

.footer-section ul li a.router-link-exact-active{
    background-color: transparent;
}

.extra-content {
    display: flex;
    gap: 80px;
}

.footer-section h5{
    margin-bottom: 8px;
}

.footer-section ul {
    list-style: none;
    padding: 0;
    margin-top: 10px;
}

.footer-section ul li {
    margin: 2px 0;
}

.footer-section ul li a {
    text-decoration: none;
    color: initial;
}
.dark-theme .footer-section ul li a{
    color: #fff;
}

.footer-section ul li a:hover {
    text-decoration: underline;
}

@media (max-width: 1210px) {
    .extra-content{
        gap: 50px;
    }
}

@media (max-width: 999px) {
    .footer{
        padding: 20px 0;
    }
    .footer-box ul{
        margin-top: 0px !important;
    }
    .footer-content {
        flex-direction: column;
        text-align: center;
        gap: 12px;
        display: block;
    }

    .main-section {
        width: 100%;
    }

    .footer-section h5, .footer-section p{
        display: none;
    }

    .extra-content {
        flex-direction: column;
        gap: 0px;
        overflow: hidden;
        transition: all 0.35s ease;
        width: 100%;
    }

    .extra-content.visible {
        max-height: 700px;
        opacity: 1;
        gap: 0;
    }

    .expand-toggle {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        font-weight: bold;
        width: 100%;
    }

    .arrow {
        font-size: 12px;
        transition: transform 0.25s ease;
    }

    .arrow.open {
        transform: rotate(180deg);
    }

    .footer-section{
        margin: 10px 0;
    }
}
</style>
